﻿angular.module('projectModule')
    .service('ntaDiagram',
        ['$rootScope', '$log', '$http', 'ntabuilding', 'ntaEntityDataOrg', 'ntaData', 'ntaSharedLogic', 'ntaRounding', 'ntaMeldingen',
function ($rootScope,   $log,   $http,   ntabuilding,   ntaEntityDataOrg,   ntaData,   ntaSharedLogic,   ntaRounding,   ntaMeldingen) {
    'use strict';
    const self = this;

    ntabuilding.ntaDiagram = self; //-- ntaDiagram aan ntabuilding geven, omdat deze nodig is voor het sluiten van de DiagramWindow als er naar het projectenoverzicht wordt gegaan.

    /// == Imports ================================================================================

    /// == Instance variables =====================================================================
    let _diagramWindow;
    let _climateData = [];
    let _verbruikData = [];
    let _entdataEnergierekening = ntaEntityDataOrg.getFirstWithEntityId('ENER-REK');
    let _entdataClimate = ntaEntityDataOrg.getFirstWithEntityId('CLIMATE');
    let _entdataVerbruikOverig = ntaEntityDataOrg.getFirstWithEntityId('VERBR-OVERIG');

    /// == Exports ================================================================================

    Object.assign(self, {
        // methods
        canShowDiagramWindow,
        showDiagramWindow,
        closeWindow,
        updateAllDataDiagramWindow,
        updateVerbruikDiagramWindow,
    });

    /// == Initialization =========================================================================

    $rootScope.$on('updateResults', function (event, results) {
        if (!results.VariantId) {
            updateAllDataDiagramWindow({ refreshVerbruik: true, refreshClimate: false });
        }
    });

    window.addEventListener("beforeunload", event => {
        closeWindow(); //evt. openstaand diagramWindow sluiten.
    });


    /// == Implementation =========================================================================

    function postMessage(action, data = []) {
        if (_diagramWindow && !_diagramWindow.closed) {
            const message = {
                buildingId: ntabuilding.buildingId,
                action,
                data,
            };
            _diagramWindow.postMessage(message, window.origin);
        }
    } //-- end: postMessage -----------------------------------------------------------------------

    function canShowDiagramWindow() {
        // gebruik [ER-L] om te bepalen of de knop ‘Grafiek fitten’ weergegeven moet worden.
        const propDoelEnergierekening = ntaData.properties['ENER-REK_DOEL'];
        return !!propDoelEnergierekening && propDoelEnergierekening.Domain.Codes.some(cv => cv.Id === "ENER-REK_DOEL1");
    } //-- end: canShowDiagramWindow --------------------------------------------------------------

    async function showDiagramWindow() {
        //conditie [MW-AN] als op de knop gedrukt wordt EN
        // - bij ER02 is gekozen voor alleen terugverdientijd berekenen geef[W123]
        // - als berekening Calcneeded = true dan geef[W122]
        if (_entdataEnergierekening && _entdataEnergierekening.PropertyDatas['ENER-REK_DOEL'].Value === 'ENER-REK_DOEL3') {
            await ntaMeldingen.warning('[W123]');
            return;
        }
        if (ntaEntityDataOrg.getCalculationNeeded(ntabuilding.buildingId)) {
            await ntaMeldingen.warning('[W122]');
            return;
        }

        //opnieuw ophalen -> er kan een andere berekening zijn geopend.
        _entdataEnergierekening = ntaEntityDataOrg.getFirstWithEntityId('ENER-REK');
        _entdataClimate = ntaEntityDataOrg.getFirstWithEntityId('CLIMATE');
        _entdataVerbruikOverig = ntaEntityDataOrg.getFirstWithEntityId('VERBR-OVERIG');

        if (!_diagramWindow) {
            window.addEventListener('message', onDiagramMessage);
        }
        if (!_diagramWindow || _diagramWindow.closed) {
            const projectId = ntaData.projectdata.ProjectId;
            const buildingId = ntabuilding.buildingId;
            const url = `/Project/${projectId}/Berekening/${buildingId}/Grafiek_Fitten`;

            const width = window.outerWidth / 1.25;
            const left = window.screenLeft + width;
            const height = window.outerHeight / 1.75;
            const top = window.screenTop + height;

            _diagramWindow = window.open(url, '_blank', `popup,left=${left},width=${width},top=${top},height=${height}`);
            // als het goed is, stuurt dat venster een ‘requestData’ om de gegevens op te halen
        }
        _diagramWindow.focus();
    } //-- end: showDiagramWindow -----------------------------------------------------------------

    function closeWindow() {
        postMessage('closeWindow');
    } //-- end: closeWindow -----------------------------------------------------------------------

    async function updateAllDataDiagramWindow(refresh) {
        if (_diagramWindow && !_diagramWindow.closed) {
            if (refresh.refreshVerbruik) {
                getVerbruikData();
            }
            if (refresh.refreshClimate) {
                await getClimateData();
            }

            postMessage('allData', {
                projectName: ntaData.projectdata.Name,
                buildingName: ntaEntityDataOrg.getFirstWithEntityId('GEB').PropertyDatas['GEB_OMSCHR'].Value,
                verbruikdata: _verbruikData,
                klimaatdata: _climateData,
            });
        }
    } //-- end: updateAllDataDiagramWindow --------------------------------------------------------

    function updateVerbruikDiagramWindow(prop, verbruik) {
        if (_diagramWindow && !_diagramWindow.closed) {
            const carrier = (prop.Id === 'VERBR_E_TLEV' || prop.Id === 'VERBR_E_OPWEK')
                ? 'E_LEV'
                : prop.Id.split('VERBR_').pop();
            postMessage('updateData', createCarrierVerbruikData(verbruik, carrier));
        }
    } //-- end: updateVerbruikDiagramWindow -----------------------------------------------------------------------

    function onDiagramMessage(event) {
        if (event.origin !== window.origin) {
            return $log.warn('SECURITY: message from unexpected origin', event.origin, '; expected origin:', window.origin);
        }
        if (!event.data.action) {
            return;
        }
        if (!_diagramWindow) {
            return $log.warn('SECURITY: received message while diagram window is disconnected!', event);
        }
        if (event.data.buildingId !== ntabuilding.buildingId) {
            return $log.warn('SECURITY: message for unexpected buildingId', event.data.buildingId, '; expected:', ntabuilding.buildingId);
        }
        switch (event.data.action) {
            case 'requestData':
                updateAllDataDiagramWindow({ refreshVerbruik: true, refreshClimate: true });
                break;

            case 'choiceUpdated':
                const row = event.data.data;
                const props = new Map([['verbrNietRepres', 'VERBR_NIET_REPRES'], ['verbrInStookseizoen', 'VERBR_IN_STOOKSEIZOEN'], ['verbrBtnStookseizoen', 'VERBR_BTN_STOOKSEIZOEN']]);
                props.forEach(function (value, key) {
                    const propId = value + '_' + row['typeCarrier'];
                    const verbruik = ntaData.original.get(row['verbrId']);
                    const newValue = row[key];
                    saveValue(propId, verbruik, newValue)
                });
                break;
        }
    } //-- end: onDiagramMessage ------------------------------------------------------------------

    function getVerbruikData() {
        // VERBR_ID | TYPE_CARRIER | VERBR_VERBR_MJ (maand) | VERBR | VERBR_FITTED (resultaat FG03) | VERBR_NIET_REPRES | VERBR_IN_STOOKSEIZOEN | VERBR_BTN_STOOKSEIZOEN
        // verbrId  | typeCarrier  | VerbrMJ (maand)        | verbr | verbrFitted (resultaat FG03)  | verbrNietRepres   | verbrInStookseizoen   | verbrBtnStookseizoen
        _verbruikData = [];
        const isFittenPerJaar = _entdataEnergierekening && _entdataEnergierekening.PropertyDatas['ENER-REK_DOEL'].Value === 'ENER-REK_DOEL2';
        const verbruiken = isFittenPerJaar ?
            ntaEntityDataOrg.getListWithEntityId('VERBR').filter(x => x.PropertyDatas['VERBR_VERBR_MJ'].Value === 'VERBR_MJ_JR') :
            ntaEntityDataOrg.getListWithEntityId('VERBR').filter(x => x.PropertyDatas['VERBR_VERBR_MJ'].Value !== 'VERBR_MJ_JR');
        const carriers = ["E_LEV", ...[...ntaSharedLogic.getDragerAanwezigMap()].filter(([k, v]) => v.verbruiken).map(([key]) => key)];
        for (const verbruik of verbruiken) {
            for (const carrier of carriers) {
                if (isChecked(carrier) && carrier !== 'E') { //check of carrier is aangevinkt en mee mag
                    _verbruikData.push(createCarrierVerbruikData(verbruik, carrier));
                }
            }
        }
    } //-- end: getVerbruikData ------------------------------------------------------------------

    function createCarrierVerbruikData(verbruik, carrier) {
        //-> Guid, GAS, januari, 64, 67, true, false, false
        const propMJ = ntaData.properties['VERBR_VERBR_MJ'];
        const month = propMJ.getCode(verbruik).Order;
        const isFittenPerMaand = _entdataEnergierekening && _entdataEnergierekening.PropertyDatas['ENER-REK_DOEL'].Value === 'ENER-REK_DOEL1';

        //default value stookseizoen
        if (!verbruik.PropertyDatas['VERBR_IN_STOOKSEIZOEN_' + carrier].Value && !verbruik.PropertyDatas['VERBR_BTN_STOOKSEIZOEN_' + carrier].Value) {
            const propWarmteBehoefte = ntaData.properties['VERBR_WARMTE_NON'];
            if (ntaSharedLogic.parseFloat(propWarmteBehoefte.getValue(verbruik), 0) > 0) {
                //trendlijn winter (VERBR_IN_STOOKSEIZOEN) zet maanden v.d. gefitte berekening aan waarvoor geldt: ∑siQhnodin;mi (f9.5) > 0
                saveValue('VERBR_IN_STOOKSEIZOEN_' + carrier, verbruik, "1");
                saveValue('VERBR_BTN_STOOKSEIZOEN_' + carrier, verbruik, "0");
            } else {
                //trendlijn zomer (VERBR_BTN_STOOKSEIZOEN) zet maanden v.d. gefitte berekening aan waarvoor geldt: ∑siQhnodin;mi (f9.5) = 0
                saveValue('VERBR_IN_STOOKSEIZOEN_' + carrier, verbruik, "0");
                saveValue('VERBR_BTN_STOOKSEIZOEN_' + carrier, verbruik, "1");
            }
        }

        const carrierVerbruikData = {
            verbrId: verbruik.EntityDataId,
            typeCarrier: carrier,
            verbrMJ: ntaSharedLogic.getVerbruikMonthAndYear(verbruik, _entdataEnergierekening).Value,
            verbrMaand: month,
            verbr: { value: ntaSharedLogic.parseFloat(verbruik.PropertyDatas['VERBR_' + carrier].Value, 0), text: '' },
            verbrFitted: { value: ntaSharedLogic.parseFloat(verbruik.PropertyDatas['VERBR_FITTED_' + carrier].Value, 0), text: '' },
            afw: '--',
            verbrNietRepres: verbruik.PropertyDatas['VERBR_NIET_REPRES_' + carrier].Value,
            verbrInStookseizoen: verbruik.PropertyDatas['VERBR_IN_STOOKSEIZOEN_' + carrier].Value,
            verbrBtnStookseizoen: verbruik.PropertyDatas['VERBR_BTN_STOOKSEIZOEN_' + carrier].Value,
        };
        let rounding = 'R014';
        switch (carrier) {
            case 'E_LEV': {
                rounding = ntaData.properties['VERBR_E_LEV'].Rounding;
                const propdataOPW = verbruik.PropertyDatas['VERBR_E_OPWEK'];
                const propdataTLEV = verbruik.PropertyDatas['VERBR_E_TLEV'];
                const propdataOpgewekt = verbruik.PropertyDatas['VERBR_E_OPGEWEKT_NON'];
                if (propdataOPW.Relevant) {
                    //f.fg1a: e-verbruik = e-levering + e-opwekking (omvormer) - e-teruglevering
                    carrierVerbruikData.verbr.value += ntaSharedLogic.parseFloat(propdataOPW.Value, 0) - ntaSharedLogic.parseFloat(propdataTLEV.Value, 0);
                } else if (propdataTLEV.Relevant){
                    //f.fg1b: e-verbruik = e-levering + VERBR_E_OPGEWEKT_NON (SumEprelgi (uit rekenhart)) - e-teruglevering
                    carrierVerbruikData.verbr.value += ntaSharedLogic.parseFloat(propdataOpgewekt.Value, 0) - ntaSharedLogic.parseFloat(propdataTLEV.Value, 0);
                }
                break;
            }
            case 'GAS': {
                if (_entdataVerbruikOverig) {
                    rounding = ntaData.properties['VERBR_FITTED_GAS'].Rounding;
                    const propDataKokenOpGas = _entdataVerbruikOverig.PropertyDatas['VERBR-OVERIG_KOKEN_GAS'];
                    let kokenOpGas = propDataKokenOpGas.Relevant && propDataKokenOpGas.Value === 'VERBR-OVERIG_KOKEN_GAS_Y' ? 37 : 0;
                    if (isFittenPerMaand) kokenOpGas /= 12;
                    carrierVerbruikData.verbrFitted.value = (carrierVerbruikData.verbrFitted.value / 35.17 * 3.6) + kokenOpGas;
                }
                break;
            }
            case 'BIOM': {
                rounding = ntaData.properties['VERBR_FITTED_BIOM'].Rounding;
                break;
            }
            case 'OLIE': {
                rounding = ntaData.properties['VERBR_FITTED_OLIE'].Rounding;
                carrierVerbruikData.verbrFitted.value *= 0.1;
                break;
            }
            case 'W': {
                rounding = ntaData.properties['VERBR_FITTED_W'].Rounding;
                if (isFittenPerMaand) {
                     //van GJ naar MJ
                    carrierVerbruikData.verbr.value *= 1000;
                    carrierVerbruikData.verbrFitted.value *= 3.6;
                } else {
                    carrierVerbruikData.verbrFitted.value *= 3.6 / 1000;
                }
                break;
            }
            case 'K': {
                rounding = ntaData.properties['VERBR_FITTED_K'].Rounding;
                if (isFittenPerMaand) {
                    //van GJ naar MJ
                    carrierVerbruikData.verbr.value *= 1000;
                    carrierVerbruikData.verbrFitted.value *= 3.6;
                } else {
                    carrierVerbruikData.verbrFitted.value *= 3.6 / 1000;
                }
                break;
            }
        }

        // Bij fitten per maand: deel bij alle formules de uitkomst door het aantal dagen van de maand (februari altijd 28)
        if (isFittenPerMaand) {
            const daysInMonth = moment("2023-" + month.toString(), "YYYY-MM").daysInMonth(); // In 2023 heeft februari 28 dagen. Bij isFittenPerJaar delen door 1.
            carrierVerbruikData.verbr.value /= daysInMonth;
            carrierVerbruikData.verbrFitted.value /= daysInMonth;
            rounding = 'R014';
        }
        roundValueAndText(carrierVerbruikData.verbr);
        roundValueAndText(carrierVerbruikData.verbrFitted);

        //afwijking berekenen
        const afwijking = ((carrierVerbruikData.verbrFitted.value - carrierVerbruikData.verbr.value) / carrierVerbruikData.verbr.value) * 100;
        carrierVerbruikData.afw = Number.isFinite(afwijking) ? ntaRounding.roundAndAddZerosNewValue(null, afwijking, 'R016') : "--";

        return carrierVerbruikData;

        function roundValueAndText(verbr) {
            const numValue = verbr.value;
            verbr.value = ntaRounding.ntaround(numValue, rounding);
            verbr.text = ntaRounding.roundAndAddZerosNewValue(null, numValue, rounding);
        }
    } //-- end: createCarrierVerbruikData -------------------------------------------------------------

    async function getClimateData() {
        const propStation = ntaData.properties['CLIMATE_KNMI_STATION']
        const propEersteMaand = ntaData.properties['ENER-REK_EERSTEMAAND'];
        const propHitteEiland = ntaData.properties['CLIMATE_HEAT_ISLAND'];

        const station = propStation.getValue(_entdataClimate);
        const hitteEiland = propHitteEiland.getValue(_entdataClimate);
        const eersteMaand = propEersteMaand.getValue(_entdataEnergierekening);
        const start = moment(eersteMaand);
        const eind = moment(eersteMaand).add(12, 'months');

        const url = `/api/climate?station=${station}&fromYear=${start.year()}&fromMonth=${start.month() + 1}&tillYear=${eind.year()}&tillMonth=${eind.month() + 1}`;
        try {
            // Wacht op het antwoord van de server
            const response = await $http.get(url);
            _climateData = response.data;

            for (const klimaatMaand of _climateData) {
                klimaatMaand.Te = ntaRounding.ntaround(klimaatMaand.Te + ntaSharedLogic.parseFloat(hitteEiland, 0), 'R015');
            }
        } catch (response) {
            $log.error(url, response);
        }
    } //-- end: getClimateData -----------------------------------------------------------------

    function saveValue(propOrId, entdata, newValue) {
        const prop = typeof propOrId === 'string' ? ntaData.properties[propOrId] : propOrId;
        return ntaEntityDataOrg.saveprop(prop.getData(entdata), newValue);
    } //-- end: saveValue ---------------------------------------------------------------------

    function isChecked(drager) {
        const prop = ntaData.properties['ENER-REK_VERBRAANW'];
        const valuesSet = new Set(String(prop.getValue(_entdataEnergierekening)).split('|'));
        return valuesSet.has('ENER-REK_VERBRAANW_' + drager);
    } //-- end: isChecked -----------------------------------------------------------------

}]);
